module.exports = __webpack_public_path__ + "img/GS_Profile-Yoliswa Mayeza.75a9cf73.png";